<template>
    <div ref="box">
        <!-- 头部 -->
        <div class="bar-manager-header">
            <bar-header
                @refresh="refresh"
                @addAllRouterRemote="addAllRouterRemote"
            ></bar-header>
        </div>
        <!-- 表格部分 -->
        <div class="table-content">
            <bar-table-list
                ref="tableList"
                @pagechange="getBarList"
                :total="parseInt(total)"
                :page="parseInt(page)"
                :table-list="tableData.list"
            ></bar-table-list>
        </div>
    </div>
</template>

<script>
// 头部
import BarHeader from "../../barHeader";
// 网吧列表
import BarTableList from "../../barTableList";

import { getBarList } from "@/requests/bar";

export default {
    name: "allBar",
    components: {
        BarHeader,
        BarTableList
    },
    data() {
        return {
            total: 0,
            page: 1,
            tableData: {
                list: []
            },
            tableLoading: false
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.getBarList(1);
        });
    },
    watch: {
        /* eslint-disable */
        $route(to, from) {
            this.getBarList(1);
        }
    },
    methods: {
        // 获取所有网吧列表
        async getBarList(pageNum) {
            this.tableData.list = [];
            this.tableLoading = true;
            let res = await getBarList({
                pageNum,
                pageSize: 20,
                groupId: "",
                searchTxt: this.$route.query.search
            });
            this.tableData.list = res.records;
            this.total = parseInt(res.total);
            this.page = parseInt(res.current);
            this.$store.state.barDetails.searchBarNum = this.total;
            this.tableLoading = false;
        },
        addAllRouterRemote() {
            if (this.$refs.tableList.selectedBarIds().length == 0) {
                return window.$Message.show({
                    title: "提示",
                    type: "info",
                    msg: "请选择选择网吧"
                });
            }
            window.$modal.setRouterRemoteModal.show(
                { barId: this.$refs.tableList.selectedBarIds().join(",") },
                0,
                true
            );
        },
        async refresh() {
            await this.getBarList(this.page);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";

.bar-manager-header {
    height: 70px;
    line-height: 70px;
    border-bottom: 1px solid #d9dee4;
}
.table-content {
    padding-top: 10px;
    padding-left: 30px;
    padding-right: 30px;
}
.table-pagination {
    text-align: right;
    padding-right: 80px;
    padding-top: 20px;
    > div {
        display: inline-block;
    }
}
</style>
